import { render, staticRenderFns } from "./allotMenuCSG.vue?vue&type=template&id=041b9af8&scoped=true"
import script from "./allotMenuCSG.vue?vue&type=script&lang=js"
export * from "./allotMenuCSG.vue?vue&type=script&lang=js"
import style0 from "./allotMenuCSG.vue?vue&type=style&index=0&id=041b9af8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b9af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041b9af8')) {
      api.createRecord('041b9af8', component.options)
    } else {
      api.reload('041b9af8', component.options)
    }
    module.hot.accept("./allotMenuCSG.vue?vue&type=template&id=041b9af8&scoped=true", function () {
      api.rerender('041b9af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/role/allotMenuCSG.vue"
export default component.exports